export default __webpack_public_path__ + "static/typography-image-g-fedbae48ac40591b853142ad5068e802.png";